export default __webpack_public_path__ + "static/media/sandalias-hombre.1c8e09e3.png";